import { DeepPartial } from '../types/deep-partial';

const defaultTheme = {
  size: {
    width: 1366,
    height: 768,
    maxCodePaneHeight: 200
  },
  colors: {
    primary: '#ebe5da',
    secondary: '#fc6986',
    tertiary: '#1e2852',
    quaternary: '#ffc951',
    quinary: '#8bddfd'
  },
  fonts: {
    header: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    text: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    monospace: '"Consolas", "Menlo", monospace'
  },
  fontSizes: {
    h1: '72px',
    h2: '64px',
    h3: '56px',
    text: '44px',
    monospace: '20px'
  },
  space: [16, 24, 32]
};

export type SpectacleTheme = typeof defaultTheme;
export type SpectacleThemeOverrides = DeepPartial<SpectacleTheme>;

export default defaultTheme;
